import React, { useState } from 'react';
import {
  Pane, majorScale, TextInput, FormField, toaster,
} from 'evergreen-ui';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { api } from '../../../../services/api';
import BaseSheet from '../../../../components/sidesheets/base';
import { CustomTagInput } from '../../../../components/inputs';
import formHelp from '../../../../constants/help';

const CreateTeamSheet = ({ visible, close }) => {
  const [submitLoading, setSubmitLoading] = useState(false);

  const validateForm = (values) => {
    const errors = {};
    if (!values.name || values.name.length < 1) {
      errors.name = 'This field is required';
    }
    return errors;
  };

  const submitForm = async (values) => {
    setSubmitLoading(true);
    try {
      await api.teams.create(values);
      toaster.success('Team created successfully');
      close();
    } catch (error) {
      toaster.danger('There was an error while proccessing your request');
    }
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: submitForm,
    validate: validateForm,
    validateOnChange: true,
  });

  const form = (
    <Pane>
      <FormField label="Team name" validationMessage={formik.errors.name}>
        <TextInput
          name="name"
          disabled={submitLoading}
          onChange={formik.handleChange}
          isInvalid={formik.errors.name && true} />
      </FormField>
      <FormField label="Team aliases" marginTop={majorScale(2)}>
        <CustomTagInput
          disabled={submitLoading}
          onChange={(values) => formik.setFieldValue('aliases', values)} />
      </FormField>
    </Pane>
  );

  return (
    <BaseSheet.Create
      form={form}
      close={close}
      help={formHelp.team}
      visible={visible}
      submitLoading={submitLoading}
      submitDisabled={Object.keys(formik.errors).length > 0}
      title="Create a new team"
      onSubmit={formik.handleSubmit} />
  );
};

CreateTeamSheet.propTypes = {
  visible: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default CreateTeamSheet;
